import { Controller } from "@hotwired/stimulus"

// Debounced auto-submit for the admin student search form.
//
// The form targets a Turbo frame (`students-results`), so submitting re-renders
// only the results list while the search input — which lives OUTSIDE the frame —
// keeps focus and caret position mid-typing. With JS disabled the visible
// "Search" button still performs a normal full-page GET.
export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } }

  disconnect() {
    clearTimeout(this.timeout)
  }

  submit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, this.delayValue)
  }
}
